// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__mrN4C","list":"styles_list__1hFLh"};